import { useTranslation } from "react-i18next";
import { Magicpen } from "iconsax-react";
import { Badge } from "@/shared/ui";

export default function DemoBadge() {
  const { t } = useTranslation("DemoPage");

  return (
    <span title={t("badge.hint")}>
      <Badge
        variant="soft"
        color="notice"
        text={t("badge.label")}
        icon={<Magicpen size={14} color="currentColor" />}
      />
    </span>
  );
}
